import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { PaginatedResponse } from '@shared/models';
import { NotificationDto, NotificationFilterDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  list(filter: NotificationFilterDto = {}): Observable<PaginatedResponse<NotificationDto>> {
    const params = this.buildParams(filter);
    return this.http.get<PaginatedResponse<NotificationDto>>(
      `${this.baseUrl}notifications`,
      { params },
    );
  }

  markAsRead(id: number): Observable<NotificationDto> {
    return this.http.post<NotificationDto>(
      `${this.baseUrl}notifications/${id}/read`,
      {},
    );
  }

  markAllAsRead(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}notifications/read-all`, {});
  }

  private buildParams(filter: NotificationFilterDto): HttpParams {
    let params = new HttpParams();
    if (filter.type) params = params.set('type', filter.type);
    if (filter.unreadOnly !== undefined) params = params.set('unreadOnly', String(filter.unreadOnly));
    if (filter.page !== undefined) params = params.set('page', filter.page.toString());
    if (filter.limit !== undefined) params = params.set('limit', filter.limit.toString());
    if (filter.sortBy) params = params.set('sortBy', filter.sortBy);
    if (filter.sortOrder) params = params.set('sortOrder', filter.sortOrder);
    return params;
  }
}
